<template>
  <div>
    <div class="d-flex justify-end align-center mb-3" v-if="$auth.policies['update-event']">
      <v-btn color="primary" class="white--text" outlined @click="onCreate"><v-icon>add</v-icon>Thêm lớp</v-btn>
    </div>
    <MenuSettingItems :items="items" @onEdit="onEdit" @onRemove="onRemove" @onUpdateIndex="onUpdateIndex" />
    <div v-if="!items.length" class="text-center">Chưa tồn tại lớp nào</div>
    <EventSlotPopup ref="event-slot-popup" />
  </div>
</template>
<script>
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import EventSlotPopup from './EventSlotPopup.vue'
import MenuSettingItems from './MenuSettingItems.vue'

export default {
  components: { MenuSettingItems, EventSlotPopup },
  computed: {
    ...mapGetters({ items: 'eventSlots/getItems' })
  },
  methods: {
    ...mapActions({
      remove: 'eventSlots/remove',
      updateIndex: 'eventSlots/updateIndex'
    }),
    onCreate() {
      this.$refs['event-slot-popup'].openDialog('create')
    },
    onEdit(item = {}) {
      this.$refs['event-slot-popup'].openDialog('edit', item)
    },
    onRemove(item = {}) {
      this.$dialog.confirm({
        title: 'Xác nhận xoá lớp',
        text: `Bạn có chắc chắn muốn xoá lớp "${item.title}"?\n Thao tác này sẽ không thể hoàn tác`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(item.id)
            this.$alert.success(`Xoá lớp "${item.title}" thành công`)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    async onUpdateIndex(item) {
      const { dragNode, targetPath } = item
      try {
        this.$loading.active = true
        await this.updateIndex({ id: dragNode.id, newIndex: get(targetPath, '0') })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
